import { Box, Loader } from '@mantine/core';
import UnderlineTabsDeprecated from '../UI/page-nav/UnderlineTabsDeprecated';
import { ClientsTable } from './ClientsTable';
import { FamiliesTable } from './FamiliesTable';
import { ClientTabs, useClientTab } from './hooks/useClientTab';
import { useParams } from 'react-router';
import { FamilyClientsTable } from './components/FamilyClientsTable';
import useCurrentUser from 'src/admin/users/hooks/useCurrentUser';
import { useClientsContext } from 'src/clients/context/ClientsContext';

export default function ClientsPage() {
  const { currentTab, setTab } = useClientTab();
  const { id } = useParams<{ id?: string }>();
  const { currentUser, isLoading: isCurrentUserLoading } = useCurrentUser();
  const { startClientCreation } = useClientsContext();

  const tabContent = getTabContent(currentUser, currentTab, id, startClientCreation);

  if (isCurrentUserLoading) {
    return (
      <Box p="md" style={{ textAlign: 'center' }}>
        <Loader />
      </Box>
    );
  }

  return (
    <Box p="md">
      <UnderlineTabsDeprecated
        value={currentTab}
        onChange={value => {
          if (value != null) {
            setTab(value as ClientTabs);
          }
        }}
      >
        <UnderlineTabsDeprecated.List>
          <UnderlineTabsDeprecated.Tab value={ClientTabs.Clients}>
            Clients
          </UnderlineTabsDeprecated.Tab>
          <UnderlineTabsDeprecated.Tab value={ClientTabs.Families}>
            Families
          </UnderlineTabsDeprecated.Tab>
        </UnderlineTabsDeprecated.List>

        <Box mt="sm">{tabContent}</Box>
      </UnderlineTabsDeprecated>
    </Box>
  );
}

function getTabContent(
  currentUser: { id?: string; userRole: string } | undefined,
  currentTab: string | undefined,
  id: string | undefined,
  startClientCreation: () => void,
) {
  if (!currentUser?.id) return null;

  const filters = ['SYSTEM_ADMIN', 'SERVICE_ADMIN'].includes(currentUser.userRole)
    ? undefined
    : { advisorUserId: currentUser.id };

  if (currentTab === ClientTabs.Clients) {
    return (
      <ClientsTable
        filters={filters}
        primaryButton={{
          label: 'Add client',
          onClick: startClientCreation,
        }}
      />
    );
  }
  if (currentTab === ClientTabs.Families) {
    if (id != null) {
      return <FamilyClientsTable id={id} />;
    }

    return <FamiliesTable filters={filters} />;
  }
  return null;
}
